import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";
import StraightLine from "./StraightLine";

/**
 * SROC (Smoothed Price Rate-of-Change, FML.SROC) — painel próprio:
 * linha ROC + linha de sinal ROCMA (só quando M ≠ 0, espelhando o
 * `Visible = M != 0` do engine) + linha zero tracejada.
 * yAccessor(d) retorna { roc, rocma }.
 */
class SROCSeries extends Component {
  constructor(props) {
    super(props);
    this.rocAccessor = this.rocAccessor.bind(this);
    this.rocmaAccessor = this.rocmaAccessor.bind(this);
  }
  rocAccessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.roc;
  }
  rocmaAccessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.rocma;
  }
  render() {
    const { strokeRoc, strokeRocma, strokeZeroLine, m, className } = this.props;
    return (
      <g className={className}>
        <LineSeries
          yAccessor={this.rocAccessor}
          stroke={strokeRoc}
          fill="none"
        />
        {Number(m) !== 0 && (
          <LineSeries
            yAccessor={this.rocmaAccessor}
            stroke={strokeRocma}
            fill="none"
          />
        )}
        <StraightLine yValue={0} stroke={strokeZeroLine} />
      </g>
    );
  }
}

SROCSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  strokeRoc: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  strokeRocma: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  strokeZeroLine: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  m: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

SROCSeries.defaultProps = {
  strokeRoc: { color: "#FFFF00" },
  strokeRocma: { color: "#FF0000" },
  strokeZeroLine: { color: "#0000B4", dash: "Dash", width: 1, opacity: 1 },
  m: 0,
  className: "react-stockcharts-sroc-series",
};

export default SROCSeries;
